<template>
  <div>
    <Navbar :toReset="(url) => this.reset(url)" />
    <div class="d-flex" id="wrapper">
      <div class="bg-light border-right" id="sidebar-wrapper">
        <Sidebar active="Rawat Inap" :toReset="(url) => this.reset(url)" />
      </div>
      <div id="page-content-wrapper">
        <div class="container-fluid">
          <Alert
            v-if="saveFailed"
            :alert="{
              type: 'danger',
              title: 'Gagal Menyimpan Rawat Inap',
              content:
                'Tidak dapat membuat lebih dari 1 Rawat Inap untuk nomor rawat yang sama',
            }"
          />
          <Alert
            v-if="saveSuccess"
            :alert="{
              type: 'success',
              title: 'Berhasil Menyimpan Data',
              content: 'Penyimpanan data berhasil dilakukan',
            }"
          />
          <PageContentHeader
            :data="data"
            :fromUrl="fromUrl || ''"
            :fromTab="$route.query.fromTab || ''"
          />
          <DetailTop v-if="detailTop" :detailTop="detailTop" />
          <div class="row mb-4" v-if="detailLeftTop || detailRightTop">
            <div class="col-md-7 pr-1" v-if="detailLeftTop">
              <DetailLeft :detailLeftTop="detailLeftTop" />
            </div>
            <div class="col-md-5 pl-1" v-if="detailRightTop">
              <DetailRight :detailRightTop="detailRightTop" />
            </div>
          </div>
          <!--form action="/ranap/save" method="POST" enctype="multipart/form-data"-->

          <div class="row mb-5">
            <div class="col-md-6">
              <FormRow
                v-for="row in leftFormEdit"
                v-bind:key="row.colnum + String(Math.random(1023))"
                :row="row"
                @handleChange="(e) => handleChange(e)"
              />
              <FormRow
                v-for="row in rightFormEdit"
                v-bind:key="row.colnum + String(Math.random(1023))"
                :row="row"
                @handleChange="(e) => handleChange(e)"
              />
            </div>
            <div class="col-md-6">
              <FormRow
                v-for="row in uploadFormEdit"
                v-bind:key="row.colnum + String(Math.random(1023))"
                :row="row"
                @handleChange="(e) => handleChange(e)"
              />
            </div>
          </div>
          <div class="py-1 my-5"></div>
          <div class="card p-3 float-bottom">
            <div class="row">
              <div class="col-md-12">
                <button
                  @click="handleForm"
                  class="
                    btn btn-primary btn-with-icon-left
                    float-right
                    ml-3
                    text-uppercase
                  "
                >
                  <i class="material-symbols-outlined">check_circle</i>
                  Ubah Data Rawat Inap
                </button>
                <!-- <router-link
                  class="btn btn-outline-danger btn-no-outline float-right text-uppercase"
                  :to="`/ranap/detail/${$route.params.id_ranap}`"
                >Batalkan</router-link> -->
                <a
                  class="
                    btn btn-outline-danger btn-no-outline
                    float-right
                    text-uppercase
                  "
                  @click="
                    () => goBack(`/ranap/detail/${$route.params.id_ranap}`)
                  "
                  >Batalkan
                </a>
              </div>
            </div>
          </div>

          <!--/form-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Navbar from "@/components/Navbar.vue";
import Sidebar from "@/components/Sidebar.vue";
import PageContentHeader from "@/components/PageContentHeader.vue";
import FormRow from "@/components/FormRow.vue";
import DetailTop from "@/components/DetailTop.vue";
import DetailLeft from "@/components/DetailLeft.vue";
import DetailRight from "@/components/DetailRight.vue";
import Alert from "@/components/Alert.vue";
import {
  resetForms,
  setPatientIntro,
  setRawatIntro,
  doubleDigit,
  getFullUrl,
} from "@/data/helper.js";
// import { HTTP } from "@/config.js";
import {
  dataEdit,
  leftFormEdit,
  rightFormEdit,
  uploadFormEdit,
  today,
  time,
} from "@/data/RanapForm.js";
export default {
  name: "RanapForm",
  components: {
    Navbar,
    Sidebar,
    PageContentHeader,
    FormRow,
    DetailTop,
    DetailLeft,
    DetailRight,
    Alert,
  },
  data: () => {
    return {
      fromUrl: "",
      plainUrl: "",
      rooms: [],
      data: dataEdit,
      detailTop: null,
      detailLeftTop: null,
      detailRightTop: null,
      leftFormEdit: leftFormEdit,
      ralan: {},
      doubleDigit: doubleDigit,
      rightFormEdit: rightFormEdit,
      uploadFormEdit: uploadFormEdit,
      ranap: null,
      file_permintaan_ranap_lama: "",
      file_pengkajian_awal_lama: "",
      file_asesmen_resiko_lama: "",
      file_catatan_obat_lama: "",
      file_ringkasan_masuk_lama: "",
      file_resume_medis_lama: "",
      file_resume_pulang_lama: "",
      formSet: {
        id_kamar: "",
        id_dokter: "",
        id_petugas: "",
        tgl_masuk: today,
        jam_masuk: time,
        dgs_awal: "",
        file_permintaan_ranap: "",
        file_pengkajian_awal: "",
        file_asesmen_resiko: "",
        soap_dokter: "",
        soap_perawat: "",
        file_catatan_obat: "",
        file_ringkasan_masuk: "",
        file_resume_medis: "",
        file_resume_pulang: "",
      },
      saveSuccess: false,
      saveFailed: false,
    };
  },
  methods: {
    goBack(url) {
      // //console.log(this.fromUrl);
      let urlArray = this.fromUrl.split("?");
      let backBtn = urlArray[0];
      // //console.log(backBtn);
      // //console.log(window.history.back);

      if (
        !backBtn ||
        this.fromUrl.indexOf("form") > -1 ||
        this.fromUrl.indexOf("edit") > -1 ||
        this.fromUrl.indexOf("cetak") > -1
      ) {
        if (url)
          this.$router.push({
            path:
              url +
              (this.$route.query.fromTab
                ? "?tab=" + this.$route.query.fromTab
                : ""),
          });
        else this.$router.go(-1);
      } else if (this.$route.query.fromTab) {
        let queryString = "?";
        let tabQuery = "tab=" + this.$route.query.fromTab;
        if (urlArray[1]) {
          if (urlArray[1].toLowerCase().indexOf(tabQuery.toLowerCase()) < 0) {
            if (urlArray[1].indexOf("tab=") > -1) {
              let queryArray = urlArray[1].split("tab=");
              if (queryArray[1]) {
                let restQueryArray = queryArray[1].split("&");
                restQueryArray[0] = this.$route.query.fromTab;
                queryArray[1] = restQueryArray.join("&");
              }
              urlArray[1] = queryArray.join("tab=");
            } else {
              queryString += tabQuery + "&";
            }
          }
          queryString += urlArray[1];
        } else {
          queryString += tabQuery;
        }
        // //console.log(backBtn)
        this.$router.push({ path: backBtn + queryString });
      } else {
        // //console.log(window.history);
        let queryString = "";
        if (urlArray[1]) {
          queryString += "?" + urlArray[1];
        }
        this.$router.push({ path: backBtn + queryString });
      }
    },
    getDateEnd: function(start, n) {
      //console.log(start);
      let dt = new Date(start);
      var theDay = new Date();
      theDay.setDate(dt.getDate() + parseInt(n) - 1);
      var day =
        theDay.getFullYear() +
        "-" +
        this.doubleDigit(theDay.getMonth() + 1) +
        "-" +
        this.doubleDigit(theDay.getDate());
      //console.log(day);
      return day;
    },
    getDaysArray: function(start, n) {
      let arr = [];
      //console.log(start);
      let dt = new Date(start);
      arr.push(start);
      for (var i = 1; i < n; i++) {
        //console.log(i);
        var theDay = new Date();
        theDay.setDate(dt.getDate() + i);
        var day =
          theDay.getFullYear() +
          "-" +
          this.doubleDigit(theDay.getMonth() + 1) +
          "-" +
          this.doubleDigit(theDay.getDate());
        //console.log(day);
        arr.push(day);
      }
      //console.log(arr);
      return arr;
    },
    handleForm: async function() {
      this.errors = [];
      let formData = new FormData();
      // let formTagihan = new FormData();
      // let body = "";
      var self = this;
      let valid = this.validateForm();
      if (valid) {
        Object.keys(this.formSet).forEach(function(key) {
          if (self.formSet[key]) {
            if (
              !(
                [
                  "file_permintaan_ranap",
                  "file_pengkajian_awal",
                  "file_asesmen_resiko",
                  "file_catatan_obat",
                  "file_ringkasan_masuk",
                  "file_resume_medis",
                  "file_resume_pulang",
                ].indexOf(key) > -1 && self.formSet[key] == self[key + "_lama"]
              )
            ) {
              formData.append(key, self.formSet[key]);
            }
          }
        });

        try {
          let result = await this.$store.state.HTTP.post(
            `ranap/${self.$route.params.id_ranap}`,
            formData
          );
          //console.log(result);
          if (result.status == "200") {
            self.saveFailed = false;
            self.saveSuccess = true;
            setTimeout(function() {
              self.saveSuccess = false;
              self.$router.push(`/ranap/detail/${self.$route.params.id_ranap}`);
            }, 1000);
          } else {
            //console.log(result.status);
            this.errors.push(result.status);
            this.saveFailed = true;
          }
        } catch (e) {
          //console.log(e);
          this.errors.push(e);
          this.saveFailed = true;
        }
      } else {
        //console.log("tidak valid");
      }
    },
    reset(url, stay) {
      // if (this.validated) {
      resetForms(
        this.formSet,
        [this.leftFormEdit, this.rightFormEdit, this.uploadFormEdit],
        true,
        this.handleChange
      );
      // }
      if (!url) {
        this.$router.go(-1);
      } else {
        ////console.log(url);
        this.$router.push(url);
      }
    },
    handleChange(e) {
      //console.log(this.leftFormEdit);
      //console.log(this.rightFormEdit);
      //console.log(this.formSet);
      if (e.target.type == "file") {
        if (e.target.files && e.target.files.length) {
          this.formSet[e.target.name] = e.target.files[0];
        }
      } else {
        this.formSet[e.target.name] = e.target.value;
      }
      if (e.target.name == "same_as_ralan") {
        //console.log(e.target.value);

        // this.formSet[e.target.name] = e.target.value;
        this.leftFormEdit[3].columns[0].value = this.formSet[e.target.name];
        if (e.target.value == "Ya") {
          this.formSet["id_dokter"] = this.ralan.id_dokter;
          //console.log(this.formSet['id_dokter']);
        } else {
          this.formSet["id_dokter"] = "";
        }
        // this.leftFormEdit[2].columns[0].value=this.formSet['id_dokter'];
        // this.$set(this.leftFormEdit[2].columns[0],'value',this.formSet['id_dokter']);
        // this.leftFormEdit.splice(2,1,this.leftFormEdit[2]);
        // this.leftFormEdit.splice(3,1,this.leftFormEdit[3]);
        //console.log(this.leftFormEdit);
      } else if (e.target.name == "id_kamar") {
        this.setPrice(e.target.value);
      } else if (e.target.name == "jumlah") {
        this.formSet.jumlah = e.target.value;
        this.formSet.tgh_kamar =
          parseInt(this.formSet.satuan) * parseInt(this.formSet.jumlah);
        this.rightFormEdit[1].columns[0].value = this.formSet.jumlah;
        this.rightFormEdit[1].columns[2].value = this.formSet.tgh_kamar;
      }
    },
    setPrice: async function(id_kamar) {
      //console.log(id_kamar);
      //console.log(this.rooms);
      // let result = await this.$store.state.HTTP.get(`ranap/fasilitas/kamar/${id_kamar}`);
      //console.log(result);
      let room = this.rooms.find(function(room) {
        return room.id == id_kamar;
      });
      //console.log(room);
      if (room) {
        this.formSet.satuan = room.biaya;
      } else {
        this.formSet.satuan = 0;
      }
      this.rightFormEdit[1].columns[1].value = this.formSet.satuan;
      this.formSet.tgh_kamar =
        parseInt(this.formSet.satuan) * parseInt(this.formSet.jumlah);
      this.rightFormEdit[1].columns[2].value = this.formSet.tgh_kamar;
      // this.rightFormEdit()
    },
    validateForm: function() {
      let valid = true;
      let self = this;
      //console.log(self.formSet);
      let forms = [this.leftFormEdit, this.rightFormEdit].map(function(form) {
        form = form.map(function(row) {
          row.columns = row.columns.map(function(column) {
            //console.log(column.value);
            //console.log(column.optional);
            //console.log(self.formSet[column.name]);
            if (
              !column.optional &&
              column.type != "hidden" &&
              !self.formSet[column.name]
            ) {
              valid = false;
              column.error = "Kolom ini wajib diisi";
            } else if (
              [
                "number",
                "money",
                "addon-right",
                "addon-left",
                "percentage",
              ].indexOf(column.type) > -1 &&
              !column.negativeValue &&
              parseInt(self.formSet[column.name]) < 0
            ) {
              valid = false;
              column.error = "Nilai yang diisi tidak boleh negatif";
            } else {
              column.error = "";
            }
            if (self.formSet[column.name]) {
              column.value = self.formSet[column.name];
            }
            return column;
          });
          return row;
        });
        return form;
      });
      this.leftFormEdit = forms[0];
      this.rightFormEdit = forms[1];
      return valid;
    },
    fetchRooms: async function() {
      //console.log('ranap');
      //console.log(this.ranap);
      //console.log('ranap');

      try {
        let result = await this.$store.state.HTTP.get(
          "ranap/fasilitas/kamar?per_page=9999999999&status=KOSONG"
        );
        //console.log(result);
        if (result.status == "200") {
          //console.log(result.data);
          this.rooms = result.data.data;
          if (this.ranap && this.ranap.kamar_ranap) {
            this.formSet["id_kamar"] = this.ranap.kamar_ranap.id;
            this.rooms = [this.ranap.kamar_ranap, ...this.rooms];
          }
          //console.log(doctors);
          this.leftFormEdit[1].columns[0].options = this.rooms.map(function(
            item
          ) {
            item.label = `${item.formatted_kelas} | ${item.nama}  [ ${item.formatted_no_kasur} ]`;
            item.value = item.id;
            return { label: item.label, value: item.value };
          });
          if (this.formSet["id_kamar"]) {
            this.leftFormEdit[1].columns[0].value = this.formSet["id_kamar"];
            this.updateForm();
          }
        } else {
          this.displayNotFoundError();
        }
      } catch (e) {
        //console.log(e);
      }
    },
    fetchDoctors: async function() {
      try {
        let result = await this.$store.state.HTTP.get(
          "dokter?per_page=9999999999"
        );
        //console.log(result);
        if (result.status == "200") {
          //console.log(result.data);
          let doctors = result.data.data;
          //console.log(doctors);
          this.leftFormEdit[2].columns[0].options = doctors.map(function(item) {
            item.label = `${item.kode} | ${item.nama}`;
            item.value = item.id;
            return { label: item.label, value: item.value };
          });
          this.leftFormEdit[2].columns[0].value = this.formSet["id_dokter"];
          this.leftFormEdit.splice(2, 1, this.leftFormEdit[2]);
          //console.log(this.leftFormEdit);
        } else {
          this.displayNotFoundError();
        }
      } catch (e) {
        //console.log(e);
      }
    },
    fetchNurses: async function() {
      try {
        let result = await this.$store.state.HTTP.get(
          `petugas?per_page=9999999999`
        );
        //console.log(result);
        if (result.status == "200") {
          this.rightFormEdit[0].columns[0].options = result.data.data.map(
            (item) => {
              return { value: item.id, label: item.nama };
            }
          );
        } else {
          this.displayNotFoundError();
        }
      } catch (e) {
        //console.log(e);
      }
    },
    displayData: async function() {
      try {
        let result = await this.$store.state.HTTP.get(
          `ranap/${this.$route.params.id_ranap}`
        );
        //console.log(result);
        if (result.status == "200") {
          this.ranap = result.data;
          let self = this;
          Object.keys(this.formSet).forEach(function(key) {
            if (
              [
                "file_permintaan_ranap",
                "file_pengkajian_awal",
                "file_asesmen_resiko",
                "file_catatan_obat",
                "file_ringkasan_masuk",
                "file_resume_medis",
                "file_resume_pulang",
              ].indexOf(key) > -1
            ) {
              var url = getFullUrl(
                self.$store.state.baseStorageURL,
                self.ranap[key]
              );
              self[key + "_lama"] = url;
              self.formSet[key] = url;
            } else {
              self.formSet[key] = self.ranap[key];
            }
          });
          this.updateForm();
        } else {
          this.errors.push(result.status);
        }
      } catch (e) {
        //console.log(e);
        this.errors.push(e);
      }
    },
    updateForm() {
      let self = this;
      let forms = [
        this.leftFormEdit,
        this.rightFormEdit,
        this.uploadFormEdit,
      ].map(function(form) {
        form = form.map(function(row) {
          row.columns = row.columns.map(function(column) {
            if (self.formSet[column.name]) {
              column.value = self.formSet[column.name];
            }
            return column;
          });
          return row;
        });
        return form;
      });
      this.leftFormEdit = forms[0];
      this.rightFormEdit = forms[1];
      this.uploadFormEdit = forms[2];
      //   this.fetchDoctors();
    },
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  // created() {
  //   window.addEventListener(
  //     "hashchange",
  //     () => {
  //       // Do something when the hash changes
  //       location.reload();
  //     },
  //     false
  //   );
  // },
  mounted: async function() {
    this.data.backBtn = "/ranap/detail/" + this.$route.params.id_ranap;
    this.data.breadcrumb[0].link =
      "/ranap/detail/" + this.$route.params.id_ranap;
    this.formSet["no_rm"] = this.$route.params.no_rm;
    if (this.$route.query.id_kamar) {
      this.formSet["id_kamar"] = this.$route.query.id_kamar;
    }
    try {
      let result = await this.$store.state.HTTP.get(
        `ralan/${this.$route.params.id}`
      );
      //console.log(result);
      if (result.status == "200") {
        //console.log('ralan');
        //console.log(result.data);
        this.ralan = result.data;
        this.detailTop = setPatientIntro(result.data.pasien);
        let detailRawat = setRawatIntro(result.data);
        this.detailLeftTop = detailRawat.detailLeftTop;
        this.detailRightTop = detailRawat.detailRightTop;
        //console.log('ralan');
        this.formSet["no_rawat"] = result.data.no_rawat;
        this.formSet["darurat"] = result.data.darurat;
        this.formSet["no_rm"] = result.data.pasien.no_rm;
        this.formSet["id_dokter"] = result.data.id_dokter;

        //console.log(this.formSet['no_rawat']);
        // this.formSet['id_dokter']=this.ralan.id_dokter;
      } else {
        this.displayNotFoundError();
      }
    } catch (e) {
      //console.log(e);
    }
    this.fetchNurses();
    this.fetchDoctors();
    await this.displayData();
    this.fetchRooms();
  },
};
</script>
